import {Validators} from '@angular/forms';
import {Injectable} from '@angular/core';

@Injectable()
export class CustomValidators {
    private static pricePatternExp = /^\d+(\.\d{1,2})?$/;

    constructor() {
    }

    public static priceValidator() {
        return Validators.pattern(this.pricePatternExp);
    }
}


// unamePattern = "^[a-z0-9_-]{8,15}$";
// pwdPattern = "^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?!.*\s).{6,12}$";
// mobnumPattern = "^((\\+91-?)|0)?[0-9]{10}$";
// emailPattern = "^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,4}$";